import styled from 'styled-components'
import { ChangeEvent, useCallback, useEffect, useState } from 'react'

import { Dialog } from 'components/Dialog/Dialog'
import { Button } from 'components/Button/Button'
import { useViewAsWallet } from 'contexts/ViewAsWalletContext'

interface Props {
  isOpen: boolean
  onClose: () => void
}

const Input = styled.input`
  box-sizing: border-box;
  width: 100%;
  font-family: ${({ theme }) => theme.typography.family.Poppins} !important;
  background-color: transparent;
  border: none;
  color: ${p => p.theme.colors.text.primary};
  font-size: ${p => p.theme.typography.size.Description}px;
  &::placeholder {
    color: ${p => p.theme.colors.input.placeholder};
  }
`

const InputContainer = styled.div`
  border: 1px solid ${p => p.theme.colors.border};
  padding: 8px 12px;
  border-radius: 16px;
  margin-top: 16px;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 32px;
`

export const ViewAsWalletDialog = ({ isOpen, onClose }: Props) => {
  const [viewAsWalletAddress, setViewAsWalletAddress] = useState('')

  const {
    viewAsWalletAddress: viewAsWalletAddressStored,
    onViewAsWalletAddressChange,
    onCancelViewAsWallet,
  } = useViewAsWallet()

  useEffect(() => {
    if (isOpen) {
      setViewAsWalletAddress(viewAsWalletAddressStored)
    }
  }, [viewAsWalletAddressStored, isOpen])

  const onChangeAddress = useCallback((e: ChangeEvent<HTMLInputElement>) => setViewAsWalletAddress(e.target.value), [])

  const onSubmit = useCallback(() => {
    onViewAsWalletAddressChange(viewAsWalletAddress)
    onClose()
  }, [viewAsWalletAddress, onViewAsWalletAddressChange, onClose])

  const onExitViewAsMode = useCallback(() => {
    onCancelViewAsWallet()
    onClose()
  }, [onCancelViewAsWallet, onClose])

  return (
    <Dialog title="View as wallet" isOpen={isOpen} onClose={onClose}>
      <InputContainer>
        <Input
          value={viewAsWalletAddress}
          onChange={onChangeAddress}
          id="view-as-address-id"
          name="View as address value"
          placeholder="Enter view as wallet address"
        />
      </InputContainer>
      <ButtonsContainer>
        <Button onClick={onSubmit} style={{ width: '100%', marginTop: 32 }} disabled={viewAsWalletAddress === ''}>
          Submit
        </Button>
        <Button
          outlined
          onClick={onExitViewAsMode}
          style={{ width: '100%', marginTop: 32 }}
          disabled={viewAsWalletAddressStored === ''}
        >
          Exit "View as wallet" mode
        </Button>
      </ButtonsContainer>
    </Dialog>
  )
}
